import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useDevice } from '../Device';
import { Box, Column } from '../Layout';
import styles from './FullPageModalContentCard.module.scss';
export function FullPageModalContentCard(param) {
    let { children, gap = 16, className, contentClassName, transparentMobile, testId } = param;
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsx(Box, {
        className: cn(styles.page, {
            [styles.pageMobile]: isMobileDevice,
            [styles.pageMobileTransparent]: isMobileDevice && transparentMobile
        }, className),
        testId: testId,
        children: /*#__PURE__*/ _jsx(Column, {
            gap: gap,
            className: cn(styles.card, {
                [styles.cardMobile]: isMobileDevice,
                [styles.cardMobileTransparent]: isMobileDevice && transparentMobile
            }, contentClassName),
            testId: testId && "".concat(testId, "-card"),
            children: children
        })
    });
}
